import { useState, useCallback } from 'react';
import { highlightQuery } from '../utils/syntax-highlight';
import type { QueryLanguage } from '@cade/syntax-highlight';

interface Props {
  code: string;
  language: QueryLanguage;
}

const LANG_LABELS: Record<QueryLanguage, string> = {
  spl: 'SPL',
  kql: 'KQL',
  sql: 'SQL',
  lucene: 'Lucene',
};

export function QueryBlock({ code, language }: Props) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard API may not be available
    }
  }, [code]);

  const highlighted = highlightQuery(code, language);

  return (
    <div className="query-block">
      <div className="query-block-header">
        <span className={`query-block-lang query-block-lang-${language}`}>
          {LANG_LABELS[language]}
        </span>
        <button
          className={`query-block-copy ${copied ? 'copied' : ''}`}
          onClick={handleCopy}
          type="button"
        >
          {copied ? (
            <>
              <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
                <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Copied
            </>
          ) : (
            <>
              <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
                <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
                <path d="M11 5V3.5A1.5 1.5 0 009.5 2h-6A1.5 1.5 0 002 3.5v6A1.5 1.5 0 003.5 11H5" stroke="currentColor" strokeWidth="1.2"/>
              </svg>
              Copy
            </>
          )}
        </button>
      </div>
      <div
        className="query-block-code"
        dangerouslySetInnerHTML={{ __html: highlighted }}
      />
    </div>
  );
}
